import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useStyles } from '../../../components'
// import { getItem, listItems } from '../lib/api-onlpos'

export function DataProvider({ Component, ...rest }) {
  const { shopInfo, selectedLanguage } = useSelector((state) => state.shop)
  const { itemList3, itemOptions3 } = useSelector((state) => state.items)
  const { cartItems } = useSelector((state) => state.cart)
  const { isMobileDevice, isTablet, isMobilePhone } = useSelector(
    (state) => state.platform,
  )
  const { gStyle, colors } = useStyles()

  // const lang = setLanguage(selectedLanguage)
  // const texts = lang

  useEffect(() => {
    // onload()
  }, [])

  //
  // common Api test
  //
  const onload = async () => {
    try {
      let res = {}

      // res = await getItem({ model: 'shop', key: { shopId: shopInfo.shopId } })
      // if (res.err) throw Error(res.err.message)
      // console.log('-'.repeat(50), 'commonApi shop')
      // console.log('res', res.result)

      // res = await listItems({ model: 'shop-item', key: { shopId: shopInfo.shopId } })
      // if (res.err) throw Error(res.err.message)
      // console.log('-'.repeat(50), 'commonApi shop-item', res.result.Items.length)
    } catch (e) {
      alert(e.message)
    }
  }

  const allProps = {
    // ...props,
    ver: 'v3',
    shopInfo,
    itemList: itemList3,
    itemOptions: itemOptions3,
    itemOptions2: itemOptions3,
    cartItems,
    isMobileDevice,
    isTablet,
    isMobilePhone,
    // lang, texts,
    gStyle,
    colors,
  }
  return <Component {...rest} {...allProps} />
}
